
import { useState, useEffect } from "react";
import calendarStyles from "pages/landingpage/calendar/CalendarSection.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./singelWorkTime.module.css";
import Popup from "components/Popup/popup";
import { WorkTimeSlot, HolidaySlot } from "modules/calendar-worktime-holiday";
import { fetchWorkSlots, fetchHolidaySlots } from "services/workTime/calendar-service";

import { getMonday, getWeekdayLetter, isSameDate, uniqueTimeSlots } from "utils/calender";
import CalendarControler from "components/calender/calenderController";
import React from "react";
import ErrorFailed from "components/errorFailed/errorFailed";
import { setHolyday } from "services/workTime/set-hoiday";
import { fetchBookings, fetchBookingsInterval } from "utils/workTime";
import { formatDate } from "utils/bookingPopup";
import SuccessPopup from "components/successPopup/successPopup";
import { IoIosList } from "react-icons/io";
import { IoCalendarOutline } from "react-icons/io5";
import HolydayList from "./holydayList";



export default function SingelWorkTime() {
    const [workTimeSlots, setWorkTimeSlots] = useState<WorkTimeSlot[]>([]);
    const [holidaySlots, setHolidaySlots] = useState<HolidaySlot[]>([]);
    const [weekOffset, setWeekOffset] = useState(0);
    const [week, setWeek] = useState<Date[]>([]);
    const currentTime = new Date();
    const times = uniqueTimeSlots(workTimeSlots, week);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selectedTimeSlots, setSelectedTimeSlots] = useState<string[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [isFullDayClosed, setIsFullDayClosed] = useState(false);
    const [displayedTimeSlots, setDisplayedTimeSlots] = useState<string[]>([]);
    const [selectedSlotIds, setSelectedSlotIds] = useState<number[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [bookingsForDeletion, setBookingsForDeletion] = useState<{ id: number; age: number; recurrence?: string, date: Date, isprimey: boolean, name: string, block: string }[]>([]);
    const [showConfirmHolydayPopup, setShowConfirmHolydayPopup] = useState(false);
    const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
    const [selectedView, setSelectedView] = useState('table');
    const handleTableView = () => setSelectedView('table');
    const handlelistView = () => setSelectedView('list');
    const fetchData = async () => {
        try {
            const workData = await fetchWorkSlots();
            const holidayData = await fetchHolidaySlots();
            setWorkTimeSlots(workData);
            setHolidaySlots(holidayData);

        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    useEffect(() => {
        fetchData();
        updateWeeks(0);
    }, []);

    const updateWeeks = (offset: number) => {
        const monday = getMonday(new Date());
        const newMonday = new Date(monday);
        newMonday.setDate(monday.getDate() + offset * 7);

        const newWeek = [];
        for (let i = 0; i < 28; i++) {
            const currentDay = new Date(newMonday);
            currentDay.setDate(newMonday.getDate() + i);
            if (currentDay.getDay() >= 1 && currentDay.getDay() <= 5) {
                newWeek.push(currentDay);
            }
        }

        setWeek(newWeek);
    };

    const confirmholyday = async () => {
        const formData = {
            startDate,
            endDate,
            isFullDayClosed,
            slotIds: selectedSlotIds
        };
        try {
            setHolyday(formData, bookingsForDeletion);
            setIsSuccessPopupOpen(true);

        } catch (error) {
            console.error("Error setholyday slots:", error);
        } finally {
            await fetchData();

        }

    };


    const onSubmitPopup = async () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (!startDate) {
            setError("Startdatum ist erforderlich.");
            return;
        }
        const start = new Date(startDate);
        if (start < today) {
            setError("Das Startdatum darf nicht vor dem heutigen Datum liegen.");
            return;
        }
        if (endDate) {
            const end = new Date(endDate);
            if (end < start) {
                setError("Das Enddatum darf nicht vor dem Startdatum liegen.");
                return;
            }
        }

        if (!isFullDayClosed && selectedSlotIds.length === 0) {
            setError("Mindestens ein Block muss ausgewählt werden.");
            return;
        }

        try {
            const end = endDate ? new Date(endDate) : start;
            if (isFullDayClosed) {
                const bookingsForDeletion = await fetchBookingsInterval(start, end);
                const filteredBookings = bookingsForDeletion.filter(booking => {
                    const bookingDate = new Date(booking.date);
                    return bookingDate >= start && (!end || bookingDate <= end);
                });
                setBookingsForDeletion(filteredBookings);
            } else {
                const bookingsForDeletion = await fetchBookings(selectedSlotIds, start, end);
                const filteredBookings = bookingsForDeletion.filter(booking => {
                    const bookingDate = new Date(booking.date);
                    return bookingDate >= start && (!end || bookingDate <= end);
                });
                setBookingsForDeletion(filteredBookings);
            }
            setShowConfirmHolydayPopup(true);

        } catch (error) {
            console.error("Failed to set holiday:", error);
        }
    };


    const handleOpenPopup = (day: Date, time: string) => {
        setStartDate(day.toISOString().substring(0, 10));

        const daySlots = workTimeSlots.filter(
            slot => slot.day_of_week === getWeekdayLetter(day)
        );
        const timeRanges = daySlots.map(slot =>
            `${slot.start_time.substring(0, 5)} - ${slot.end_time.substring(0, 5)}`
        );
        setDisplayedTimeSlots(timeRanges);

        const selectedSlot = daySlots.find(
            slot => `${slot.start_time.substring(0, 5)} - ${slot.end_time.substring(0, 5)}` === time &&
                slot.day_of_week === getWeekdayLetter(day)
        );

        setSelectedSlotIds(selectedSlot ? [selectedSlot.id as number] : []);

        setSelectedTimeSlots([time]);
        setIsPopupOpen(true);
    };
    
    const handleClosePopup = () => {
        setError(null);
        setIsPopupOpen(false);
        setSelectedTimeSlots([]);
        setDisplayedTimeSlots([]);
        setSelectedSlotIds([]);
        setEndDate("");
        setIsFullDayClosed(false)
        setShowConfirmHolydayPopup(false)
    };
    const handleCurrentWeek = () => {
        setWeekOffset(0);
        updateWeeks(0);
    };

    const handleNextWeek = () => {
        setWeekOffset((prevOffset) => {
            const newOffset = prevOffset + 4;
            updateWeeks(newOffset);
            return newOffset;
        });
    };

    const handlePreviousWeek = () => {
        setWeekOffset((prevOffset) => {
            const newOffset = prevOffset - 4;
            updateWeeks(newOffset);
            return newOffset;
        });
    };

    return (
        <div className={calendarStyles.container}>
            <div className={styles.CalendarControllerContaiter}>
                {selectedView === 'table' ? <div className={styles.CalendarController}>
                    <CalendarControler
                        currentDate={currentTime}
                        week={week}
                        weekOffset={weekOffset}
                        onCurrentWeek={handleCurrentWeek}
                        onPreviousWeek={handlePreviousWeek}
                        onNextWeek={handleNextWeek}
                        showPrevious={true} />

                </div> :
                    <div className={styles.CalendarController}>
                        <p>Ferien</p>
                    </div>
                }
                <div className={styles.veiwButtonContainer}>
                    <button className={`${commonStyles.commonButton}  ${selectedView === 'table' ? styles.activeViewButton : styles.viewButton}`} onClick={handleTableView}>
                        <IoCalendarOutline />
                    </button>
                    <button className={`${commonStyles.commonButton} ${selectedView === 'list' ? styles.activeViewButton : styles.viewButton}`} onClick={handlelistView}>
                        <IoIosList />
                    </button>
                </div>
            </div>
            {selectedView === 'table' ? <table className={calendarStyles.table}>
                <thead>
                    <tr>
                        <th>Uhrzeit</th>
                        {week.slice(0, 5).map((day, index) => (
                            <th key={index}>{getWeekdayLetter(day).slice(0, 2)}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {[[0, 5], [5, 10], [10, 15], [15, 20]].map((weekRange, weekIndex) => (
                        <React.Fragment key={`week-${weekIndex}`}>
                            <tr className={calendarStyles.kalenderDatum}>
                                <td className={calendarStyles.kalenderUhrzeit}>Uhrzeit</td>
                                {week.slice(weekRange[0], weekRange[1]).map((day, index) => (

                                    <td key={index} className={day < new Date() ? calendarStyles.past : ""}>
                                        <div className={isSameDate(day, currentTime)
                                            ? calendarStyles.currentDay
                                            : ""}>
                                            {day.getDate().toString().padStart(2, '0')}
                                        </div>
                                    </td>
                                ))}
                            </tr>

                            {times.map((time, index) => (
                                <tr key={`${index}-week${weekIndex + 1}`}>
                                    <td className={calendarStyles.kalenderUhrzeit}>{time}</td>
                                    {week.slice(weekRange[0], weekRange[1]).map((day, dayIndex) => {
                                        const slot = workTimeSlots.find((slot) =>
                                            slot.day_of_week === getWeekdayLetter(day) &&
                                            slot.start_time.substring(0, 5) === time.split(" - ")[0] &&
                                            slot.end_time.substring(0, 5) === time.split(" - ")[1]
                                        );
                                        const holidaysInDay = holidaySlots.filter((holidaySlot) => {
                                            const holidayDate = new Date(holidaySlot.date);
                                            return isSameDate(day, holidayDate);
                                        });

                                        const isFullClosed = holidaysInDay.some(holiday => holiday.is_full_day) ||
                                            holidaysInDay.length === workTimeSlots.filter((slot) => {
                                                return slot.day_of_week === getWeekdayLetter(day);
                                            }).length
                                        if (isFullClosed) {
                                            return index === 0 ? (
                                                <td key={dayIndex} rowSpan={times.length} className={calendarStyles.past}>
                                                    <center>
                                                        <span className={calendarStyles.geschlossen}>geschlossen</span>
                                                    </center>
                                                </td>
                                            ) : (null);
                                        } else {
                                            const isClosed = !slot || holidaysInDay.some(holiday => holiday.block === slot.id);
                                            return (
                                                <td key={dayIndex} onClick={() => handleOpenPopup(day, time)} className={isClosed ? calendarStyles.past : ""}>
                                                    <div>

                                                        {isClosed ? (
                                                            <span className={calendarStyles.geschlossen}>geschlossen</span>
                                                        ) : (
                                                            <div className={calendarStyles.platzContainer}>
                                                                <span>geöffnet</span>
                                                            </div>
                                                        )
                                                        }
                                                    </div>
                                                </td>)
                                        }
                                    })}
                                </tr>
                            ))}
                        </React.Fragment>
                    ))}
                </tbody>
            </table> : <HolydayList/>}
            {isPopupOpen && (
                <Popup
                    title={"Öffnungszeiten bearbeiten"}
                    submitLabel={"Speichern"}
                    closeLabel={"Abbrechen"}
                    isWithButton={true}
                    isOpen={isPopupOpen}
                    onClose={handleClosePopup}
                    onSubmit={onSubmitPopup}
                >{error && <ErrorFailed error={error} />}
                    <div className={commonStyles.formGroupRow}>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="startDate">Geschlossen am</label>
                            <input
                                type="date"
                                id="startDate"
                                name="startDate"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                required
                            />
                        </div>
                        <div className={commonStyles.formGroup}>
                            <label htmlFor="endDate">optional bis</label>
                            <input
                                type="date"
                                id="endDate"
                                name="endDate"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                required
                            />
                        </div>
                    </div>
                    <div className={styles.toggle}>
                        <label className={styles.switch}>
                            <input
                                type="checkbox"
                                checked={isFullDayClosed}
                                onChange={() => setIsFullDayClosed(!isFullDayClosed)}
                            />
                            <span className={styles.slider}></span>
                        </label>
                        <span className={styles.label}>ganztägig geschlossen</span>
                    </div>
                    {!isFullDayClosed && (
                        <div>
                            <label className={styles.label}>Blöcke</label>
                            <div className={styles.timeSlotOption}>
                                {displayedTimeSlots.map((timeSlot, index) => (
                                    <div key={index} className={styles.timeSlotOptionLine}>
                                        <input
                                            type="checkbox"
                                            checked={selectedTimeSlots.includes(timeSlot)}
                                            onChange={() => {
                                                const selectedSlot = workTimeSlots.find(

                                                    slot => slot.day_of_week === getWeekdayLetter(new Date(startDate)) &&
                                                        `${slot.start_time.substring(0, 5)} - ${slot.end_time.substring(0, 5)}` === timeSlot
                                                );
                                                const slotId = selectedSlot ? selectedSlot.id : null;
                                                setSelectedTimeSlots(prev =>
                                                    prev.includes(timeSlot)
                                                        ? prev.filter(t => t !== timeSlot)
                                                        : [...prev, timeSlot]
                                                );
                                                setSelectedSlotIds(prev =>
                                                    slotId && !prev.includes(slotId)
                                                        ? [...prev, slotId]
                                                        : prev.filter(id => id !== slotId)
                                                );
                                            }}
                                        />
                                        <label>{timeSlot}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </Popup>
            )}
            {showConfirmHolydayPopup && (
                <Popup
                    title={"Bestätigung der Ablehnen"}
                    submitLabel={"Ablehnen bestätigen"}
                    closeLabel={"Abbrechen"}
                    isWithButton={true}
                    isOpen={true}
                    onClose={() => setShowConfirmHolydayPopup(false)}
                    onSubmit={confirmholyday}
                >
                    {bookingsForDeletion.length != 0 ? (
                        <><ErrorFailed error={'Dieser Vorgang ist unwiderruflich.'} /><div className={commonStyles.formGroup}>
                            <div className={styles.rejectOptionsContainer}>
                                <p> Sind Sie sicher, dass Sie die Blöcke und deren Buchungen ablehnen möchten?</p>
                                <p>Folgende Buchungen sind mit den ausgewählten Blöcken verknüpft:</p>
                                {bookingsForDeletion.map((booking, index) => (
                                    <div className={styles.rejectOptionsRow} key={`${booking.id}-${booking.date}`}>
                                        <div className={styles.rejectOptionsRowLabels}>
                                            <label>
                                                {`Kind: ${booking.name}`}
                                            </label>
                                            <label>
                                                {`${booking.age} J`}
                                            </label>
                                            <label>
                                                {`${formatDate(booking.date)}`}
                                            </label>
                                            <label>
                                                {`${booking.block}`}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div></>
                    ) : (
                        <p>Es gibt keine Buchungen, die mit diesen Blöcken verknüpft sind.</p>
                    )}
                </Popup>
            )}
            <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
                handleClosePopup();
                setIsSuccessPopupOpen(false);
                fetchData();
            }} />

        </div>
    );
}


